export default "__VITE_ASSET__BAOQKzua__"